import { array, object, string } from "yup";
import PageBlock from "@page-js/Pages/Page/Editor/scripts/pageBlock";

export interface ShowcaseItem {
  title: string;
  description: string;
  image: string;
  badge?: string;
  badge_type?: "red" | "orange" | "yellow" | "green" | "blue" | "indigo" | "purple";
  tags?: string[];
  location?: string;
  start_date?: string;
  end_date?: string;
  price?: string;
  link?: string;
  link_text?: string;
}

export default class Showcase extends PageBlock {
  public getType(): string {
    return "Showcase";
  }

  protected init(): any {
    return {
      props: {
        title: "쇼케이스",
        items: [],
      },
      attrs: {},
    };
  }

  public validateOrThrow(): Promise<any> {
    const schema = object().shape({
      props: object()
        .shape({
          items: array()
            .of(
              object().shape({
                title: string().max(64).required().label("제목"),
                description: string().max(256).required().label("설명"),
                image: string().url().required().label("이미지"),
                badge: string().max(16).nullable().label("배지 텍스트"),
                badge_type: string()
                  .oneOf(["red", "orange", "yellow", "green", "blue", "indigo", "purple"])
                  .nullable()
                  .label("배지 색상")
                  .when("badge", {
                    is: (badge: string) => badge && badge.length > 0,
                    then: (schema) => schema.required("배지 색상을 선택해주세요"),
                    otherwise: (schema) => schema.nullable().transform(() => null),
                  }),
                tags: array().of(string().max(16).required()).nullable().max(3).label("태그"),
                location: string().max(128).nullable().label("위치"),
                start_date: string().nullable().label("시작일"),
                end_date: string().nullable().label("종료일"),
                price: string().max(32).nullable().label("가격"),
                link: string().url().nullable().label("링크"),
                link_text: string().max(32).nullable().label("링크 텍스트"),
              }),
            )
            .min(1)
            .max(10)
            .required()
            .label("쇼케이스 항목"),
        })
        .label("옵션"),
      attrs: object().required().label("속성"),
    });

    return schema.validate(this.toJSON(), { abortEarly: false });
  }
}
